var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts"},_vm._l((_vm.chartList),function(k,i){return _c('chart-box',{key:k.id,attrs:{"chartData":_vm.chartList[i]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }